import React from 'react'
import { useLoadScript } from '@react-google-maps/api';
import { Grid, Skeleton } from '@mui/material'
import WrappedMap from "components/commonMap/CommonMap";

function Map(props) {
  const mapUrl = process.env.REACT_APP_GOOGLE_MAP_URL;
    const { isLoaded } = useLoadScript({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
      });
      const mapURL = `${mapUrl}/js?v=3.exp&libraries=geometry,drawing,places&key=${process.env.REACT_APP_GOOGLE_API_KEY}`;
      const stop = [
        props?.paths?.[0],
        props?.paths?.[props?.paths?.length-1]
      ]
  return (
    <Grid container className="h100p">
       {!isLoaded ? (
              <Skeleton  style={{ height: '100%',width:'100%'  }} animation="wave" />
            ) : (
              <WrappedMap
                paths={props?.paths ? props?.paths : []}
                stops={stop? stop : [
                  props?.paths?.[0],
                  props?.paths[props?.paths?.length-1]
                ]}
                driverPathDetails={stop[0]}
                googleMapURL={mapURL}
                loadingElement={<div style={{ height: `100%` }} />}
                containerElement={<div className="wh100" />}
                mapElement={<div style={{ height: `100%` }} />}
                status={props?.status}
              />
            )}
    </Grid>
  )
}

export default Map
